/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBrightnessLow = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm4-7v2h-2V5h2zm0 12v2h-2v-2h2zm4.657-9.243-1.414 1.415-1.415-1.415 1.415-1.414 1.414 1.414zm-8.485 8.486-1.415 1.414-1.414-1.414 1.414-1.415 1.415 1.415zm7.071 1.414-1.415-1.414 1.415-1.415 1.414 1.415-1.414 1.414zM7.757 9.172 6.343 7.757l1.414-1.414 1.415 1.414-1.415 1.415zM19 13h-2v-2h2v2zM7 13H5v-2h2v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBrightnessLow as BrightnessLow };
